<template>
  <div id="index">
    <div class="container_overflow">
      <div class="top">
        <div
          @click="toPagesin"
          v-if="screen == 't'"
          class="showBtnText showBtnText_no"
        >
          <img src="../../assets/imgs/icon/icon_computer.png" alt />
          <p>单屏展示</p>
        </div>
        <!-- <div @click="toPage1" v-if="screen=='t'">
        <img src="../../assets/imgs/icon/icon_survey.png" alt />
        <p>展示屏</p>
        </div>-->
        <div @click="toPage2" class="showBtnText">
          <img
            style="width: 22px; height: 20px; margin-top: 2px"
            src="../../assets/imgs/icon/icon_logout.png"
            alt
          />
          <p>退出登录</p>
        </div>
      </div>
      <div class="container1200 indexCon">
        <img class="title" src="../../assets/imgs/image/tp_03.png" alt />
        <div
          class="menuBox"
          style="width: 90%; height: 32%; position: relative"
        >
          <div
            class="sinMenu"
            :class="'sinMenu' + ind"
            v-for="(item, ind) in resultMenuList"
            :key="item.path"
          >
            <router-link :to="item.path">
              <img :src="item.img" alt />
              <div class="text">{{ item.text }}</div>
            </router-link>
          </div>
        </div>
        <el-row class="bottomSurvey">
          <el-col class="left" :xs="24" :lg="12">
            <div class="surveyTime">
              <img
                class="icon"
                src="../../assets/imgs/icon/icon_bottom_survey.png"
                alt
              />
              截止日期：{{ nowDate }}
            </div>
            <div class="contentBox">
              <div class="sinAdd" v-for="item in addList" :key="item.text">
                <div class="num">
                  <img
                    src="../../assets/imgs/icon/icon_up.png"
                    v-show="item.num > 0"
                    alt
                  />
                  <img
                    src="../../assets/imgs/icon/icon_down.png"
                    v-show="item.num < 0"
                    alt
                  />
                  {{ item.num }}%
                </div>
                {{ item.text }}
              </div>
            </div>
          </el-col>
          <el-col class="right" :xs="24" :lg="12">
            <div class="surveyTime">
              <img
                class="icon"
                src="../../assets/imgs/icon/icon_bottom_survey.png"
                alt
              />
              截止日期：{{ nowDate }}
            </div>
            <div class="contentBox">
              <div class="sinAdd" v-for="item in surveyList" :key="item.text">
                <div class="num">
                  {{ item.num }}
                  <span>个</span>
                </div>
                {{ item.text }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nowDate: "",
      screen: "f",
      topIcon: [
        {
          img: require("../../assets/imgs/icon/icon_computer.png"),
          path: "/sinDisplay",
          text: "单屏展示",
        },
        {
          img: require("../../assets/imgs/icon/icon_survey.png"),
          path: "/screendisplay",
          text: "展示屏",
        },
        {
          img: require("../../assets/imgs/icon/icon_logout.png"),
          path: "/",
          text: "退出登录",
        },
      ],
      menuList: [
        {
          img: require("../../assets/imgs/icon/icon-01.png"),
          text: "工作台",
          path: "/index/workbench",
          role: ["zfyh", "yqyh", "qyyh", "gly"],
          notDept: [],
        },
        {
          img: require("../../assets/imgs/icon/icon-02.png"),
          text: "区域",
          path: "/index/area",
          role: ["zfyh", "gly"],
          notDept: [],
        },
        {
          img: require("../../assets/imgs/icon/icon-03.png"),
          text: "投资",
          path: "/index/invest",
          role: ["zfyh", "gly"],
          notDept: [],
        },
        {
          img: require("../../assets/imgs/icon/icon-04.png"),
          text: "行业",
          path: "/index/industry",
          role: ["zfyh", "gly"],
          notDept: [],
        },
        {
          img: require("../../assets/imgs/icon/icon-05.png"),
          text: "园区",
          path: "/index/garden",
          role: ["zfyh", "yqyh", "gly"],
          notDept: [],
        },
        {
          img: require("../../assets/imgs/icon/icon-06.png"),
          text: "企业",
          path: "/index/company",
          role: ["zfyh", "qyyh", "gly"],
          notDept: ["zbzzk", "fzghk", "xxhbgs", "tycs", "zbc", "xxc"],
        },
      ],
      addList: [
        {
          num: " - ",
          text: "全市工业增加值增速",
        },
        {
          num: " - ",
          text: "全市工业投资增速",
        },
      ],
      surveyList: [
        {
          num: " - ",
          text: "监测企业数",
        },
        {
          num: " - ",
          text: "监测园区数",
        },
        {
          num: " - ",
          text: "监测项目数",
        },
      ],
      userType: "",
      userDept: "",
    };
  },
  methods: {
    toPage1() {
      this.$router.push("/screendisplay");
    },
    toPagesin() {
      // this.$router.push("/sinDisplay");
      this.$router.push("/newScreen");
    },
    toPage2() {
      // this.$axios.get("system/desktop/logout").then((res) => {
      this.$axios
        .get(`system/config/selectConfigByKey?key=sso.logout`)
        .then((result) => {
          console.log(result.data.data[0].value);
          window.location = result.data.data[0].value;
        });
      // });
    },
    // toPage2() {
    //   this.$axios.get("system/desktop/logout").then(res => {
    //     window.location = "http://www.lygyhlw.com/zqfw/index.jhtml";
    //   });
    // },
    getData() {
      this.$axios.get("/business/guide/searchBaseDataShow").then((res) => {
        // console.log(res)
        this.surveyList[0].num = res.data.enterpriseNum;
        this.surveyList[1].num = res.data.parkNum;
        this.surveyList[2].num = res.data.projectNum;
        this.addList[0].num = res.data.allCityIndustryGrowthRate;
        this.addList[1].num = res.data.allCityTotalGrowthRate;
      });
    },
    getUserType() {
      this.userType = sessionStorage.getItem("userType");
      this.userDept = sessionStorage.getItem("dept");
    },
  },
  computed: {
    resultMenuList() {
      return this.menuList
        .filter((res) => {
          return res.role.includes(this.userType);
        })
        .filter((res) => {
          return !res.notDept.includes(this.userDept);
        });
    },
  },
  created() {
    this.getData();
    this.getUserType();
  },
  mounted() {
    let nowDateOri = new Date();
    this.nowDate = `${nowDateOri.getFullYear()}年${
      nowDateOri.getMonth() + 1 > 9 ? "" : 0
    }${nowDateOri.getMonth() + 1}月`;
    this.screen = sessionStorage.getItem("screen");
  },
};
</script>

<style lang="less" scoped>
div::-webkit-scrollbar {
  width: 0;
}

#index {
  // min-height: 100vh;
  height: 100%;
  background: url(../../assets/imgs/background/home_bg.gif) center no-repeat;
  background-color: #122544;

  .top {
    display: flex;
    justify-content: flex-end;
    padding-top: 30px;
    padding-right: 40px;
    color: #fff;

    div {
      margin-left: 20px;
      text-align: center;
      cursor: pointer;
    }

    p {
      margin: 4px 0;
    }

    img {
      height: 26px;
    }
  }
  .container_overflow {
    overflow: hidden;
    height: 100vh;
    .indexCon {
      display: flex;
      // height: 85%;
      width: 80%;
      height: 100%;
      flex-direction: column;
      align-items: center;
      overflow: auto;
    }

    img.title {
      height: 20%;
      // height: 180px;
      margin-top: 0;
    }

    .menuBox {
      width: 70%;
      // height: 35%;
      height: 180px;
      padding: 0;
      // padding-left: 55px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-top: 100px;
      margin-bottom: 10px;
      background: url(../../assets/imgs/background/tp_07.png) center no-repeat;
      background-size: contain;
      position: relative;
      .sinMenu {
        position: absolute;
        width: 140px;
        margin: 0 90px;
        margin-bottom: 10px;
        height: 46%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        cursor: pointer;

        .text {
          color: #fff;
          text-align: center;
        }

        img {
          height: 140px;
        }
      }
      .sinMenu0 {
        top: -120px;
        left: 28%;
      }
      .sinMenu1 {
        top: -120px;
        left: 46%;
      }
      .sinMenu2 {
        top: 34%;
        left: 6%;
      }
      .sinMenu3 {
        top: 34%;
        left: 26%;
      }
      .sinMenu4 {
        top: 34%;
        left: 48%;
      }
      .sinMenu5 {
        top: 34%;
        left: 68%;
      }
    }

    .bottomSurvey {
      // background: url(../../assets/imgs/background/index_menu_bg.png) center
      //   no-repeat;
      // background-size: cover;
      background: rgba(6, 18, 41, 0.4);
      width: 90%;
      // height: 13%;
      height: 160px;
      // margin-top: 50px;
      padding: 10px 0;
      // box-sizing: border-box;
      // display: flex;

      .left {
        box-sizing: border-box;
        border-right: 1px solid #4c5866;
        height: 100%;
        padding-left: 45px;
      }

      .right {
        height: 100%;
        padding-left: 45px;
      }

      .surveyTime {
        display: flex;
        align-items: center;
        color: rgba(255, 255, 255, 0.8);

        .icon {
          margin-right: 10px;
        }
      }

      .contentBox {
        display: flex;
        margin-top: 40px;
        justify-content: space-around;
        color: #fff;
        text-align: center;

        .sinAdd {
          width: 150px;
          height: 60px;

          .num {
            font-size: 24px;
            color: rgba(24, 226, 253, 1);
            opacity: 0.8;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

.showBtnText {
  position: relative;
  img {
    width: 24px;
    height: 26px;
  }
  p {
    display: none;
    position: absolute;
    width: 50px;
    top: 26px;
    left: -10px;
  }
}

.showBtnText:hover {
  p {
    display: block;
  }
}

@media screen and (max-width: 1440px) {
  #index {
    height: 100%;
    background: url(../../assets/imgs/background/home_bg.gif) center no-repeat;
    background-color: #122544;

    .top {
      display: flex;
      justify-content: flex-end;
      padding-top: 30px;
      padding-right: 40px;
      color: #fff;

      div {
        margin-left: 20px;
        text-align: center;
        cursor: pointer;
      }

      p {
        margin: 4px 0;
      }

      img {
        height: 26px;
      }
    }
    .container_overflow {
      overflow: hidden;
      height: 100vh;
      .indexCon {
        display: flex;
        height: 100%;
        flex-direction: column;
        align-items: center;
        overflow: auto;
      }

      img.title {
        height: 20%;
        margin-top: 0;
      }

      .menuBox {
        width: 70%;
        height: 180px;
        padding: 0;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: 100px;
        margin-bottom: 10px;
        background: url(../../assets/imgs/background/tp_07.png) center no-repeat;
        background-size: contain;
        position: relative;
        .sinMenu {
          position: absolute;
          width: 140px;
          margin: 0 90px;
          margin-bottom: 10px;
          height: 46%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;

          .text {
            color: #fff;
            text-align: center;
          }

          img {
            height: 140px;
          }
        }
        .sinMenu0 {
          top: -130px;
          left: 28%;
        }
        .sinMenu1 {
          top: -130px;
          left: 46%;
        }
        .sinMenu2 {
          top: 22%;
          left: 6%;
        }
        .sinMenu3 {
          top: 22%;
          left: 26%;
        }
        .sinMenu4 {
          top: 22%;
          left: 48%;
        }
        .sinMenu5 {
          top: 22%;
          left: 68%;
        }
      }

      .bottomSurvey {
        background: rgba(6, 18, 41, 0.4);
        width: 90%;
        height: 160px;
        padding: 10px 0;
        box-sizing: border-box;

        .left {
          box-sizing: border-box;
          border-right: 1px solid #4c5866;
          height: 100%;
          padding-left: 45px;
        }

        .right {
          height: 100%;
          padding-left: 45px;
        }

        .surveyTime {
          display: flex;
          align-items: center;
          color: rgba(255, 255, 255, 0.8);

          .icon {
            margin-right: 10px;
          }
        }

        .contentBox {
          display: flex;
          margin-top: 40px;
          justify-content: space-around;
          color: #fff;
          text-align: center;

          .sinAdd {
            width: 150px;
            height: 60px;

            .num {
              font-size: 24px;
              color: rgba(24, 226, 253, 1);
              opacity: 0.8;
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              justify-content: center;

              span {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1200px) {
  #index .container_overflow img.title {
    width: 100%;
    height: auto;
  }
  #index .container_overflow .indexCon {
    width: 90%;
    height: 110%;
  }
  #index .container_overflow {
    overflow: auto;
  }
  #index .container_overflow .menuBox {
    width: 100% !important;
    background-size: 100% 60%;
    margin-top: 20px;
    margin-bottom: 0;
    .sinMenu0 {
      top: -12%;
      left: 4%;
    }
    .sinMenu1 {
      top: -12%;
      left: 24%;
    }
    .sinMenu2 {
      top: 36%;
      left: -18%;
    }
    .sinMenu3 {
      top: 36%;
      left: 4%;
    }
    .sinMenu4 {
      top: 36%;
      left: 24%;
    }
    .sinMenu5 {
      top: 36%;
      left: 46%;
    }
  }
  #index .container_overflow .menuBox .sinMenu {
    width: 60px;
    height: 60px;
  }
  #index .container_overflow .menuBox .sinMenu img {
    width: 60px;
    height: 60px;
  }
  .text {
    width: 60px !important;
  }
  #index .container_overflow .bottomSurvey {
    width: 100%;
  }
  #index .container_overflow .bottomSurvey .left {
    border: 0;
    padding-left: 20px;
  }
  #index .container_overflow .bottomSurvey .right {
    background: rgba(6, 18, 41, 0.4);
    margin-top: 20px;
    padding-top: 10px;
    padding-left: 20px;
  }
  .showBtnText_no {
    display: none;
  }
}
</style>